import { AsyncPipe } from '@angular/common';
import { Component, inject, Signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { ManageMenuComponent } from './manage-menu/manage-menu.component';
import { environment } from '../../../environments/environment';
import { AvatarComponent } from '../../shared/components/avatar.component';
import { VersionComponent } from '../../shared/components/commit-version.component';
import { IsFalsePipe } from '../../shared/pipe/is-false.pipe';
import { IsNotEmptyPipe } from '../../shared/pipe/is-not-empty.pipe';
import { UserStore } from '../../shared/store/user.store';
import { DrawerService } from '../drawer/drawer.service';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.scss'],
  imports: [MatToolbar, VersionComponent, MatButton, MatIcon, ManageMenuComponent, AvatarComponent, AsyncPipe, IsFalsePipe, IsNotEmptyPipe],
})
export class TopNavbarComponent {
  private readonly router = inject(Router);
  private readonly drawerService = inject(DrawerService);

  environmentType = environment.envType;
  call = true;
  drawerOpened$ = this.drawerService.opened$;
  readonly userPhoto: Signal<SafeUrl> = inject(UserStore).userPhoto;

  onClick(): void {
    this.router.navigate(['/']);
  }

  openDrawer(): void {
    this.drawerService.setOpen(true);
  }

  closeDrawer(): void {
    this.drawerService.setOpen(false);
  }
}
